var _style, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.1,
    height: 144.7
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{opacity:.53;fill:#fff}")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2,
    cy: 69.2,
    fill: "#fff",
    opacity: 0.37,
    rx: 75.1,
    ry: 69,
    transform: "rotate(-10.312 84.195 69.225)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.5,
    cy: 71.8,
    className: "st1",
    rx: 69.1,
    ry: 77.6,
    transform: "rotate(-84.811 77.545 71.797)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.3,
    cy: 72.7,
    className: "st1",
    rx: 73.2,
    ry: 70.5,
    transform: "rotate(-49.617 81.332 72.671)"
  })));
};
export { SvgCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTkuMSIgaGVpZ2h0PSIxNDQuNyIgdmlld0JveD0iMCAwIDE1OS4xIDE0NC43Ij48c3R5bGU+LnN0MXtvcGFjaXR5Oi41MztmaWxsOiNmZmZ9PC9zdHlsZT48ZWxsaXBzZSB0cmFuc2Zvcm09InJvdGF0ZSgtMTAuMzEyIDg0LjE5NTUgNjkuMjI1MikiIGN4PSI4NC4yIiBjeT0iNjkuMiIgcng9Ijc1LjEiIHJ5PSI2OSIgb3BhY2l0eT0iLjM3IiBmaWxsPSIjZmZmIi8+PGVsbGlwc2UgdHJhbnNmb3JtPSJyb3RhdGUoLTg0LjgxMTMgNzcuNTQ1MyA3MS43OTY3KSIgY2xhc3M9InN0MSIgY3g9Ijc3LjUiIGN5PSI3MS44IiByeD0iNjkuMSIgcnk9Ijc3LjYiLz48ZWxsaXBzZSB0cmFuc2Zvcm09InJvdGF0ZSgtNDkuNjE3IDgxLjMzMjMgNzIuNjcxMykiIGNsYXNzPSJzdDEiIGN4PSI4MS4zIiBjeT0iNzIuNyIgcng9IjczLjIiIHJ5PSI3MC41Ii8+PC9zdmc+";